module.exports = __webpack_public_path__ + "static/media/23.8afa8cd4.jpg";